/**
 * Hero Banner — lightweight replacement for slideshow.js
 * Handles: transparent header text colour + hosted video autoplay on mobile
 */
document.addEventListener('DOMContentLoaded', function () {

  const hero = document.querySelector('.main-slideshow');
  if (!hero) return;

  // Transparent header colour
  const header = document.querySelector('theme-header');
  if (header && header.classList.contains('transparent--true')) {
    const sectionIndex = hero.dataset.sectionIndex;
    let i = sectionIndex;

    if (Shopify.designMode) {
      const children = [...hero.closest('.shopify-section').parentNode.children];
      i = children.indexOf(hero.closest('.shopify-section')) + 1;
    }

    if (i == 1 && hero.classList.contains('change-header--true')) {
      const colorText = getComputedStyle(hero).getPropertyValue('--color-text');
      header.style.setProperty('--color-header-transparent-text', colorText);
    }

    if (i == 1 && hero.classList.contains('section-spacing--disable-top')) {
      hero.classList.add('slideshow--top');
    }
  }

  // Hosted video autoplay (mobile only)
  const videoContainer = hero.querySelector('.slideshow__slide-video-bg');
  if (videoContainer && window.innerWidth < 768) {
    const video = videoContainer.querySelector('video');
    if (video) {
      video.setAttribute('playsinline', '');
      video.setAttribute('muted', '');
      video.muted = true;
      video.playsInline = true;
      video.defaultMuted = true;
      video.play().catch(function () {
        document.addEventListener('click', function () {
          video.play();
        }, { once: true });
      });
    }
  }

});